/**
 * Notices and announcements with optional startDate and endDate (ISO YYYY-MM-DD).
 * Items with endDate in the past are hidden from banners and available in the archive.
 */

const startOfToday = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};

const parseDate = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  d.setHours(0, 0, 0, 0);
  return d;
};

/** All notices/announcements (active + archived). Add new items here. */
export const ANNOUNCEMENTS = [
  {
    id: 'mlk-day-2026',
    type: 'announcement',
    eyebrow: 'Holiday Notice',
    title: 'Martin Luther King Jr. Day',
    description: `Please note that the bank will be closed on Monday, January 19, 2026, in observance of Martin Luther King Jr. Day. We will reopen on Tuesday, January 20, 2026 during our regular business hours (excluding federal holidays).

Thank you for your continued support and cooperation.`,
    startDate: null,
    endDate: '2026-01-20',
    ctaLabel: 'Find ATM',
    ctaHref: '/location',
    iconType: 'bell',
  },


  {
    id: 'Presidents-day-2026',
    type: 'announcement',
    eyebrow: 'Holiday Notice',
    title: 'Presidents Day',
    description: `Please note that the bank will be closed on Monday, February 16, 2026, in observance of Presidents Day. We will reopen on Tuesday, February 17, 2026 during our regular business hours (excluding federal holidays).

Thank you for your continued support and cooperation.`,
    startDate: null,
    endDate: '2026-02-17',
    ctaLabel: 'Find ATM',
    ctaHref: '/location',
    iconType: 'bell',
  },


  {
    id: 'memorial-day-2026',
    type: 'announcement',
    eyebrow: 'Holiday Notice',
    title: 'Memorial Day',
    description: `Please note that the bank will be closed on Monday, May 25, 2026, in observance of Memorial Day. We will reopen on Tuesday, May 26, 2026 during our regular business hours (excluding federal holidays).
Thank you for your continued support and cooperation.`,
  
    startDate: null,
    endDate: '2026-05-26',
    ctaLabel: 'Find ATM',
    ctaHref: '/location',
    iconType: 'bell',
  },

  {
    id: 'memorial-day-2026',
    type: 'announcement',
    eyebrow: 'Holiday Notice',
    title: 'Memorial Day',
    description: `Please note that the bank will be closed on Monday, May 25, 2026, in observance of Memorial Day. We will reopen on Tuesday, May 26, 2026 during our regular business hours (excluding federal holidays).
Thank you for your continued support and cooperation.`,
  
    startDate: null,
    endDate: '2026-05-26',
    ctaLabel: 'Find ATM',
    ctaHref: '/location',
    iconType: 'bell',
  },


  {
    id: 'budkin-day-2026',
    type: 'announcement',
    eyebrow: 'Closure Notice',
    title: 'Bud Billiken Parade',
    description: `  Dear Valued Customers,
  Please be informed that the bank will be closed on Saturday, August 8, 2026, as a result of the Bud Billiken Parade celebration. We will resume work on Monday, August 10, 2026, during our regular banking hours.`,
  
    startDate: null,
    endDate: '2026-1-26',
    ctaLabel: 'Find ATM',
    ctaHref: '/location',
    iconType: 'bell',
  },










  {
    id: 'Juneteenth-day-2026',
    type: 'announcement',
    eyebrow: 'Holiday Notice',
    title: 'Juneteenth Day',
    description: `Please note that the bank will be closed on Friday, June 19, 2026, in observance of Juneteenth Day. We will reopen on Saturday, June 20, 2026 during our regular business hours (excluding federal holidays).
Thank you for your continued support and cooperation.`,
  
    startDate: null,
    endDate: '2026-06-20',
    ctaLabel: 'Find ATM',
    ctaHref: '/location',
    iconType: 'bell',
  },

  {
    id: 'Fourthofjuly-day-2026',
    type: 'announcement',
    eyebrow: 'Holiday Notice',
    title: 'Independence Day',
    description: `Please note that the bank will be closed on Friday, July 3rd and Saturday 4th, 2026, in observance of Independence Day. We will reopen on Monday, July 6, 2026 during our regular business hours.
Thank you for your continued support and cooperation.`,
  
    startDate: null,
    endDate: '2026-07-06',
    ctaLabel: 'Find ATM',
    ctaHref: '/location',
    iconType: 'independence',
    theme: 'independence-day',
  },



    {
    id: 'labor-day-2026',
    type: 'announcement',
    eyebrow: 'Holiday Notice',
    title: 'Labor Day',
    description: `Please be informed that the bank will be closed on Saturday September 5, and Monday September 7, 2026, in honor of Labor Day celebration. We will resume work on Tuesday, September 8, 2026, during our regular banking hours.
Thank you , for your continued support and cooperation.`,
  
    startDate: '2026-08-20',
    endDate: '2026-09-08',
    ctaLabel: 'Find ATM',
    ctaHref: '/location',
    iconType: 'independence',
    theme: 'independence-day',
  },

  {
    id: 'columbus-day-2026',
    type: 'announcement',
    eyebrow: 'Holiday Notice',
    title: 'Columbus Day',
    description: `  Please be informed that the bank will be closed on Monday, October 12, 2026, in honor of the Columbus Day celebration. We will resume work on Tuesday, October 13, 2026, during our regular banking hours`,
  
    startDate: '2026-10-08',
    endDate: '2026-10-13',
    ctaLabel: 'Find ATM',
    ctaHref: '/location',
    iconType: 'laborday',
    theme: 'labor-day',
  },


 




  {
    id: 'service-interruption-sample',
    type: 'incident',
    eyebrow: 'Service Change',
    title: 'GN Bank Service Change',
    description: 'Dear Valuded Customer; Starting September 1st , Cashier’s checks that remain uncashed for more than 60 days will be voided, and applicable stop-payment or reissuance fees may apply. Accounts with balances below $100 will incur a $15 monthly service fee unless they receive at least $3,000 in qualifying ACH direct deposits or maintain $4,000 in combined eligible deposit balances. The Bank generally retains records for five years, and older records may be unavailable, while requests requiring additional research may be subject to a fee.',
    startDate: '2026-09-08',
    endDate: "2026-09-08",
    ctaLabel: null,
    ctaHref: null,
    iconType: 'star',
  },
];

export const incident = [
  {
    id: 'service-interruption-sample',
    type: 'incident',
    eyebrow: 'Service Change',
    title: 'GN Bank Service Change',
    description: 'Dear Valuded Customer; Starting September 1st , Cashier’s checks that remain uncashed for more than 60 days will be voided, and applicable stop-payment or reissuance fees may apply. Accounts with balances below $100 will incur a $15 monthly service fee unless they receive at least $3,000 in qualifying ACH direct deposits or maintain $4,000 in combined eligible deposit balances. The Bank generally retains records for five years, and older records may be unavailable, while requests requiring additional research may be subject to a fee.',
    startDate: '2026-08-08',
    endDate: "2026-09-08",
    ctaLabel: null,
    ctaHref: null,
    iconType: 'star',
  },
];
/**
 * Returns items that should be shown now: no endDate or endDate >= today.
 * Optional startDate: only show if startDate <= today.
 */
export function getActiveAnnouncements(type = null) {
  const today = startOfToday();
  return ANNOUNCEMENTS.filter((item) => {
    const end = parseDate(item.endDate);
    const start = parseDate(item.startDate);
    const expired = end != null && end < today;
    const notYetStarted = start != null && start > today;
    const typeMatch = type == null || item.type === type;
    return typeMatch && !expired && !notYetStarted;
  });
}



export function getActiveIncidents(type = null) {
  const today = startOfToday();
  return incident.filter((item) => {
    const end = parseDate(item.endDate);
    const start = parseDate(item.startDate);
    const expired = end != null && end < today;
    const notYetStarted = start != null && start > today;
    const typeMatch = type == null || item.type === type;
    return typeMatch && !expired && !notYetStarted;
  });
}








/**
 * Returns items that have expired (endDate in the past), with dates preserved for archive.
 * Sorted by endDate descending (most recent first).
 */
export function getArchivedAnnouncements(type = null) {
  const today = startOfToday();
  const archived = ANNOUNCEMENTS.filter((item) => {
    const end = parseDate(item.endDate);
    const expired = end != null && end < today;
    const typeMatch = type == null || item.type === type;
    return typeMatch && expired;
  });
  return archived.sort((a, b) => {
    const da = parseDate(a.endDate)?.getTime() ?? 0;
    const db = parseDate(b.endDate)?.getTime() ?? 0;
    return db - da;
  });
}
